import Typed from 'typed.js';

window.vgTyped = {
	init: (container) => {
		let typed = document.querySelectorAll(container);
		if (typed.length) {
			for (let item of typed) {
				new Typed(item, vgTyped.typedOption(item).option);
			}
		}
	},

	typedOption: (element) => {
		const getText = (el) => {
			return el.split('|');
		};

		const getData = (attr, value) => {
			let attribute = element.getAttribute(attr);
			if(/^[0-9]+$/.test(attribute)) {
				let num = Number(attribute);
				return num || value;
			}
			return attribute || value;
		};

		const option = {
			strings: getText(getData('data-text', element.textContent)),
			typeSpeed: getData('data-typeSpeed', 50),
			backSpeed: getData('data-backSpeed', 50),
			backDelay: getData('data-backDelay', 1000),
			startDelay: getData('data-startDelay', 50),
			loop: getData('data-loop', false),
			smartBackspace: getData('data-smartBackspace', false),
		};

		return {
			option
		}
	}
};


